import * as Constants from "../constants";

let animalItemTypes = [Constants.ITEM_TYPE_BOOK_RECORD_ANIMAL, Constants.ITEM_TYPE_COLLECTIVE_HUNTING_ANIMAL, Constants.ITEM_TYPE_GROUP_HUNTING_ANIMAL];

const isCorrecting = $('#addInvoiceCorrection, #editInvoiceCorrection').length > 0;
const isCorrectionEditing = $('#editInvoiceCorrection').length > 0;


/**
 * @param {InvoiceItem} item
 * @param {number|string} priceListType
 */
export const getItemUnit = (item, priceListType) => {
  return item.getUnit(priceListType)
}

/**
 * @param {InvoiceItem} item
 * @param {number|string} priceListType
 */
export const getItemQuantity = (item, priceListType) => {
  return item.getQuantity(priceListType)
}

export const isAnimalItem = item => {
  if (typeof item.type != 'undefined') {
    if (animalItemTypes.includes(item.type)) {
      return true;
    }
  }

  return false;
}

/**
 * Generates a synchronization popover for the provided item.
 *
 * @function generateSyncPopover
 * @param form
 * @param priceListType
 * @param intendedUse
 * @param {InvoiceItem} item - The item for which the synchronization popover is created.
 * @returns {void}
 */
export const generateSyncPopover = (form, priceListType, intendedUse, item) => {
  const rows = $('tr[data-app-unique_id]');
  for(const row of rows) {
    if($(row).attr('data-app-unique_id') !== item.uniqueId) {
      continue
    }

    const trigger = $(row).find('[data-app-popover="sync"]')
    if(trigger.length === 0) {
      continue
    }

    const popover = new bootstrap.Popover(trigger[0], {
      html: true,
      title: 'Weryfikacja danych',
      trigger: 'manual',
      container: 'body',
      allowList: {
        ...bootstrap.Popover.Default.allowList,
        table: ['class'],
        tbody: [],
        td: [],
        tr: [],
        a: ['data-app-update', 'data-app-unique_id']
      },
      placement: 'top',
      content: `
        <table class="table">
            <tbody>
                ${!item.hasChanged(priceListType, intendedUse) ? `
                  <tr>
                  <td colspan="2">
                      Wszyskie dane są zgodne z danymi w systemie.
                  </td>
                  </tr>
                ` : ''}
            
                ${!item.isAnimal && item.hasChanged(priceListType, intendedUse, 'unit') ? `
                <tr>
                  <td>
                      Zmieniła się jednostka artykułu w systemie.
                      <br>
                      <small class="muted">
                        Aktualnie: ${item.getUnit(priceListType)}<br>
                        W systemie: ${item.details.unit}
                      </small>
                  </td>
                  <td>
                      <a data-app-update="unit" data-app-unique_id="${item.uniqueId}" class="btn btn-sm btn-primary">Zaktualizuj</a>
                  </td>
              </tr>
              ` : ''}
              ${item.hasChanged(priceListType, intendedUse, 'quantity') ? `
                <tr>
                  <td>
                      ${item.isAnimal ? 'Zmieniła się waga/liczba sztuk zwierzyny.' : 'Zmieniła się ilość.'}
                      <br>
                      <small class="muted">
                        Aktualnie: ${item.getQuantity(priceListType)} ${item.getUnit(priceListType)}<br>
                        W systemie: ${item.getOriginalQuantity(priceListType)} ${item.getUnit(priceListType)}
                      </small>
                  </td>
                  <td>
                      <a data-app-update="quantity" data-app-unique_id="${item.uniqueId}" class="btn btn-sm btn-primary">Zaktualizuj</a>
                  </td>
              </tr>
              ` : ''}
              ${item.hasChanged(priceListType, intendedUse, 'price') ? `
                <tr>
                  <td>
                      ${item.isAnimal ? 'Zmienił się cennik w ustawieniach lub wprowadzona cena różni się od cennika.' : 'Cena artykułu i/lub waluta różni się od tej w cenniku'}
                      <br>
                      <small class="muted">
                        Aktualnie: ${item.getPrice(intendedUse, priceListType)} ${item.getCurrency()}<br>
                        W systemie: ${item.getOriginalPrice(intendedUse, priceListType)} ${item.getOriginalCurrency()}
                      </small>
                  </td>
                  <td>
                      <a data-app-update="price" data-app-unique_id="${item.uniqueId}" class="btn btn-sm btn-primary">Zaktualizuj</a>
                  </td>
              </tr>
              ` : ''}
              ${!item.isAnimal && item.hasChanged(priceListType, intendedUse, 'currency') ? `
                <tr>
                  <td>
                      Zmieniła się waluta artykułu w systemie.
                      <br>
                      <small class="muted">
                        Aktualnie: ${item.getCurrency()}<br>
                        W systemie: ${item.getOriginalCurrency()}
                      </small>
                  </td>
                  <td>
                      <a data-app-update="currency" data-app-unique_id="${item.uniqueId}" class="btn btn-sm btn-primary">Zaktualizuj</a>
                  </td>
              </tr>
              ` : ''}
              ${!item.isAnimal && item.hasChanged(priceListType, intendedUse, 'vat') ? `
                <tr>
                  <td>
                      Zmieniła się stawka VAT dla tej pozycji w systemie
                      <br>
                      <small class="muted">
                        Aktualnie: ${item.getVat(form)}%<br>
                        W systemie: ${item.details.vat}%
                      </small>
                  </td>
                  <td>
                      <a data-app-update="vat" data-app-unique_id="${item.uniqueId}" class="btn btn-sm btn-primary">Zaktualizuj</a>
                  </td>
              </tr>
              ` : ''}
            </tbody>
        </table>
      `
    })

    trigger.on('click', function() {
      $(this).popover('show')
    })
  }
}

/**
 * @param form
 * @param intendedUse
 * @param priceListType
 * @param {InvoiceItem} item
 */
export const renderItemRow = (form, intendedUse, priceListType, item) => {
  const row = $(`<tr ${isCorrecting ? `data-app-correcting="after"` : ''} data-app-invoice_item_id="${item.invoice_item_id ?? null}" data-app-unique_id="${item.uniqueId}"></tr>`);

  if (isCorrecting) {
    row.append(`<td><small>po korekcie</small></td>`)
  }

  let isPriceNetto = true;
  if(parseInt(item.price_type) == 2 || parseInt(defaultPriceType) == 2){
    isPriceNetto = false;
  }

  row.append(`<td>${item.no ?? ''}</td>`)
  row.append(`<td>${item.name}</td>`)
  row.append(`<td>${renderUnitCell(priceListType, item)}</td>`)
  row.append(`<td>${renderQuantityCell(priceListType, item)}</td>`)
  row.append(`<td>${renderPriceCell(form,intendedUse, priceListType, item, isPriceNetto, !isPriceNetto)}</td>`)
  row.append(`<td>${renderBruttoPriceCell(form, intendedUse, priceListType, item, !isPriceNetto, !isPriceNetto)}</td>`)
  row.append(`<td>${renderVatCell(form, item)}</td>`)
  row.append(`<td>${renderQualityCell(intendedUse, priceListType, item)}</td>`)
  row.append(`
        <td class="text-end">
          <span data-bs-toggle="tooltip" title="kliknij, aby zweryfikować dane">
              <button type="button" class="btn btn-sm btn-secondary"
                data-app-popover="sync">
                Weryfikuj
              </button>
              
              <button 
                data-uuid="${item.uuid ?? null}"
                data-id="${item.id}" 
                data-type="${item.type}" 
                class="btn btn-sm btn-danger btnDeleteItem" 
                type="button">
                Usuń
            </button>
          </span>
        </td>
    `)

  return row
}

/**
 * @param form
 * @param intendedUse
 * @param priceListType
 * @param {InvoiceItem} item
 */
export const renderItemRowBeforeCorrection = (form, intendedUse, priceListType, item) => {
  const row = $(`<tr data-app-correcting="before" data-app-invoice_item_id="${item.invoice_item_id ?? null}" data-app-unique_id="${item.uniqueId}"></tr>`);

  row.append(`<td><small>przed korektą</small></td>`)
  row.append(`<td>${item.no ?? ''}</td>`)

  const is_brutto = (item.price_type == 2 || parseInt(defaultPriceType) == 2);


  if(item.isStored && (!isCorrectionEditing || item.parent)) {
    const snapshot = isCorrectionEditing ? item.parent.snapshot : item.snapshot;

    row.append(`<td>${item.name}</td>`)
    row.append(`<td>${renderUnitCell(priceListType, snapshot, false)}</td>`)
    row.append(`<td>${renderQuantityCell(priceListType, snapshot, false)}</td>`)
    row.append(`<td>${renderPriceCell(form, intendedUse, priceListType, snapshot, false,is_brutto)}</td>`)
    row.append(`<td>${renderBruttoPriceCell(form, intendedUse, priceListType, snapshot, false,is_brutto)}</td>`)
    row.append(`<td>${renderVatCell(form, snapshot, false)}</td>`)
    row.append(`<td>${renderQualityCell(intendedUse, priceListType, snapshot, false)}</td>`)
    row.append(`
          <td class="text-end">
          </td>
      `)
  } else {
    row.append(`<td>${item.name}</td>`)
    row.append(`<td>${renderUnitCell(priceListType, item, false)}</td>`)
    row.append(`<td>0</td>`)
    row.append(`<td>${renderPriceCell(form, intendedUse, priceListType, item, false,is_brutto)}</td>`)
    row.append(`<td>${renderBruttoPriceCell(form, intendedUse, priceListType, item, false,is_brutto)}</td>`)
    row.append(`<td>${renderVatCell(form, item, false)}</td>`)
    row.append(`<td>${renderQualityCell(intendedUse, priceListType, item, false)}</td>`)
    row.append(`
          <td class="text-end">
          </td>
      `)
  }

  return row
}

/**
 * @param form
 * @param intendedUse
 * @param priceListType
 * @param {InvoiceItem} item
 */
export const renderItemRowCorrectionSummary = (form, intendedUse, priceListType, item) => {
  const row = $(`<tr class="row-grayed" data-app-correcting="summary" data-app-invoice_item_id="${item.invoice_item_id ?? null}" data-app-unique_id="${item.uniqueId}"></tr>`);

  row.append(`<td><small></small></td>`)
  row.append(`<td></td>`)
  row.append(`<td></td>`)
  row.append(`<td></td>`)
  row.append(`<td></td>`)
  row.append(`<td></td>`)
  row.append(`<td></td>`)
  row.append(`<td></td>`)
  row.append(`
        <td class="text-end">
        </td>
    `)

  return row
}

/**
 * @param priceListType
 * @param {InvoiceItem} item
 * @param allowEditing
 */
const renderUnitCell = (priceListType, item, allowEditing = true) => {
  let isUnitDifferent = false;

  if (!item.isAnimal && item.getUnit(priceListType) !== item.details.unit) {
    isUnitDifferent = true;
  }

  return `
        <div>
            ${item.getUnit(priceListType)}
            
            ${(isUnitDifferent && allowEditing) ? `
                <br>
                <small title="Aktualnie: ${item.details.unit}" class="muted">Zmieniła się jednostka.</small>
                <br>
                <a data-app-update-unit data-app-id="${item.invoice_item_id}" class="link-underlined" href="#">
                    <small class="muted"><i style="font-size: 0.8em" class="fas fa-sync me-1"></i> Zaktualizuj</small>
                </a>
            ` : ''}
        </div>
    `
}

/**
 * @param priceListType
 * @param {InvoiceItem} item
 * @param allowEditing
 */
const renderQuantityCell = (priceListType, item, allowEditing = true) => {
  let isQuantityDifferent = false;

  if (item.isAnimal && item.getQuantity(priceListType) !== item.getOriginalQuantity(priceListType)) {
    isQuantityDifferent = true;
  }

  return `
        <div>
            ${(allowEditing) ? `
              ${item.isAnimal ? `
                <a data-bs-toggle="tooltip" data-app-action="edit_quantity" class="link-underlined" href="#" title="kliknij, aby edytować ilość">
                  ${item.getQuantity(priceListType)}
              </a>
              ` : `
                <input 
                    class="form-control form-control-sm" 
                    type="number" 
                    value="${item.getQuantity(priceListType)}" 
                    data-app-input="quantity"
                    style="width: 64px;"
                  />
              `}
            ` : item.getQuantity(priceListType)}
            
            ${(isQuantityDifferent && allowEditing && false) ? `
                <br>
                <small title="Aktualnie: ${item.getOriginalQuantity(priceListType)}" class="muted">Zmieniła się ilość.</small>
                <br>
                <a data-app-update-quantity data-app-id="${item.invoice_item_id}" class="link-underlined" href="#">
                    <small class="muted"><i style="font-size: 0.8em" class="fas fa-sync me-1"></i> Zaktualizuj</small>
                </a>
            ` : ''}
        </div>
    `
}

/**
 * @param form
 * @param intendedUse
 * @param priceListType
 * @param {InvoiceItem} item
 * @param allowEditing
 * @param bruttoPrice
 */
const renderPriceCell = (form, intendedUse, priceListType, item, allowEditing = true, bruttoPrice = false) => {
  let priceContent = '';

  const correctVat = item.vat ?? item.getVat(form);

  if (allowEditing && bruttoPrice) {

    priceContent = `
      <input 
          class="form-control form-control-sm me-1" 
          type="number" 
          value="${(item.getPrice(intendedUse, priceListType) / (correctVat * 0.01 + 1)).toFixed(2)}" 
          data-app-input="price"
          style="width: 64px;"
        />
    `;
  } else if (allowEditing) {
    priceContent = `
      <input 
          class="form-control form-control-sm me-1" 
          type="number" 
          value="${item.getPrice(intendedUse, priceListType)}" 
          data-app-input="price"
          style="width: 64px;"
        />
    `;
  } else if (bruttoPrice) {
    priceContent = (item.getPrice(intendedUse, priceListType) / (correctVat * 0.01 + 1)).toFixed(2);
  }
  else {
    priceContent = item.getPrice(intendedUse, priceListType) ;
  }

  return `
    <div>
      <div class="d-flex flex-row align-items-center">
        ${priceContent}
        ${item.getCurrency()}
      </div> 
    </div>
  `;
}


/**
 * @param form
 * @param intendedUse
 * @param priceListType
 * @param {InvoiceItem} item
 * @param allowEditing
 * @param bruttoPrice
 */
// const renderBruttoPriceCell = (intendedUse, priceListType, item, allowEditing = true, bruttoPrice = false) => {
//   return `
//       <div>
//         <div class="d-flex flex-row align-items-center">
//           ${(allowEditing) ? `
//               <input
//                   class="form-control form-control-sm me-1"
//                   type="number"
//                   value="${(item.getPrice(intendedUse, priceListType))}"
//                   data-app-input="price_brutto"
//                   style="width: 64px;"
//                 />
//             ` : (item.getPrice(intendedUse, priceListType) * (item.vat * 0.01 + 1)).toFixed(2)}
//              ${item.getCurrency()}
//         </div>
//       </div>
//     `;
// }

const renderBruttoPriceCell = (form, intendedUse, priceListType, item, allowEditing = true, bruttoPrice = false) => {
  let priceContent = '';

  if (allowEditing && bruttoPrice) {
    priceContent = `
      <input 
          class="form-control form-control-sm me-1" 
          type="number"
          value="${item.getPrice(intendedUse, priceListType)}"
          data-app-input="price"
          style="width: 64px;"
        />
    `;
  } else if (allowEditing) {
    priceContent = `
      <input 
          class="form-control form-control-sm me-1" 
          type="number" 
          value="${(item.getPrice(intendedUse, priceListType) * (item.vat * 0.01 + 1)).toFixed(2)}" 
          data-app-input="price"
          style="width: 64px;"
        />
    `;
  }
  else if (bruttoPrice) {
    priceContent = item.getPrice(intendedUse, priceListType)
  }
  else {
    const correctVat = item.vat ?? item.getVat(form);
    priceContent = (item.getPrice(intendedUse, priceListType) * (correctVat * 0.01 + 1)).toFixed(2)
  }

  return `
    <div>
      <div class="d-flex flex-row align-items-center">
        ${priceContent}
        ${item.getCurrency()}
      </div> 
    </div>
  `;
}
/**
 * @param form
 * @param {InvoiceItem} item
 * @param allowEditing
 */
const renderVatCell = (form, item, allowEditing = true) => {
  let isVatDifferent = false;

  if (!item.isAnimal && parseFloat(item.getVat(form)) !== parseFloat(item.details.vat)) {
    isVatDifferent = true;
  }

  return `
        <div>
            <div class="d-flex flex-row align-items-center">
                ${(!item.isAnimal && allowEditing) ? `
                  <input 
                      class="form-control form-control-sm me-1" 
                      type="number" 
                      value="${item.getVat(form)}" 
                      data-app-input="vat"
                      style="width: 64px;"
                    />
                ` : item.getVat(form)} %
            </div>
            
            ${(isVatDifferent && allowEditing && item.isAnimal && false) ? `
                <br>
                <small title="Aktualnie: ${item.details.vat}" class="muted">Zmienił się VAT.</small>
                <br>
                <a data-app-update-vat data-app-id="${item.invoice_item_id}" class="link-underlined" href="#">
                    <small class="muted"><i style="font-size: 0.8em" class="fas fa-sync me-1"></i> Zaktualizuj</small>
                </a>
            ` : ''}
        </div>
    `
}

/**
 * @param intendedUse
 * @param priceListType
 * @param {InvoiceItem} item
 * @param allowEditing
 */
const renderQualityCell = (intendedUse, priceListType, item, allowEditing = true) => {
  if (!item.isAnimal || priceListType === Constants.PRICE_LIST_FLAT_RATE) {
    return 'nie dotyczy';
  }

  let title = '';

  const prices = item.getPrices(intendedUse)

  if (!prices.price_1_class && !prices.price_2_class && !prices.price_beyond) {
    title = "Nie ustalono cen"
  }

  let selected = null;
  if (typeof item.quality != 'undefined') {
    selected = parseInt(item.quality);
  }

  return `
        <select ${allowEditing ? '' : 'disabled'} name="quality" title="${title}" data-id="${item.id}" data-type="${item.type}" class="form-select form-select-sm">
            <option ${selected === 1 && 'selected'} value="1" ${prices.price_1_class ? '' : 'disabled'}>I klasa${prices.price_1_class ? '' : ' (nie ustalono ceny)'}</option>
            <option ${selected === 2 && 'selected'} value="2" ${prices.price_2_class ? '' : 'disabled'}>II klasa${prices.price_2_class ? '' : ' (nie ustalono ceny)'}</option>
            <option ${selected === 0 && 'selected'} value="0" ${prices.price_beyond ? '' : 'disabled'}>Poza normą${prices.price_beyond ? '' : ' (nie ustalono ceny)'}</option>
        </select>
    `;
}